export default __webpack_public_path__ + "static/media/LooseLink.ae456c4e.svg";